import type { MouseEventHandler } from 'react';

export interface CookiesBannerData {}

export interface CookiesBannerProps extends CookiesBannerData {
  onAcceptClick: MouseEventHandler;
  onCustomizeClick: MouseEventHandler;
}
